import { DynamicFormV2Palette } from "@mui/material";

export type FormProgressBarComponentTokenType = {
  filledColor: string;
  trackColor: string;
};

export const assignProgressBarComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    filledColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.reverse,
    trackColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.moderate,
  } as FormProgressBarComponentTokenType;
};
